// extracted by mini-css-extract-plugin
export default {"link":"IA-z","disabled":"JA-z"};